<div class="page-header">
  <div class="page-title">
    @if(showBack()){
        <mat-icon class="go-back go-back-rotate" aria-hidden="false" svgIcon="arrow-right" (click)="goBack.emit()" />
    }
    {{ pageTitle() | translate }}
    @if (numberOfTheElements()) {
      <div class="page-header-elements-number"><span class="page-header-separator">/</span>{{ numberOfTheElements() }}</div>
    }
    @if(showToggle()) {
      <app-slide-toggle [defaultToggleState]="defaultToggleState()" [labels]="toggleLabels()" (onToggleSlide)="onToggleSlide.emit($event)" />
    }
  </div>
    <ng-content select="[actions]" />
</div>
